import ChartsPart from './parts/ChartsPart'
import CalculationsPart from './parts/CalculationsPart'
import DashasPart from './parts/DashasPart'
import StrengthPart from './parts/StrengthPart'
import YogasPart from './parts/YogasPart'
import ReportPart from './parts/ReportPart'

/**
 * Registry of Kundli Studio parts — add a component in `parts/` and one entry
 * here to ship a new section. (`soon: true` renders a disabled roadmap tab.)
 */
export const STUDIO_PARTS = [
  {
    key: 'charts',
    icon: '🌌',
    title: 'Divisional Charts',
    desc: 'Lagna, Navamsha and all 16 varga charts in the classic North Indian style.',
    Component: ChartsPart,
  },
  {
    key: 'calculations',
    icon: '🧮',
    title: 'Calculations',
    desc: 'Planet positions, houses (bhava) and the classical Avakhada table.',
    Component: CalculationsPart,
  },
  {
    key: 'dashas',
    icon: '⏳',
    title: 'Dashas',
    desc: 'The full 120-year Vimshottari cycle — Maha, Antar and Pratyantar periods.',
    Component: DashasPart,
  },
  {
    key: 'strength',
    icon: '📊',
    title: 'Ashtakavarga & Bala',
    desc: 'Shadbala strength of every graha and the Sarvashtakavarga bindu map.',
    Component: StrengthPart,
  },
  {
    key: 'yogas',
    icon: '🐍',
    title: 'Yoga & Dosha',
    desc: 'Manglik, Kalsarpa and Sadesati checks, named yogas and shanti remedies.',
    Component: YogasPart,
  },
  {
    key: 'report',
    icon: '📜',
    title: 'Life Report',
    desc: 'Classical predictions across every life area, from career to spirit.',
    Component: ReportPart,
  },
]
